import { z } from 'zod';
import { generalFormErrorMessage } from './addFuelTransactionSchema';

export const editFuelTransactionSchema = z.object({
    kilometersTotal: z.coerce
        .number({
            required_error: generalFormErrorMessage,
        })
        .min(1, {
            message: 'Dit veld is verplicht en moet groter dan 0 zijn',
        }),
    remark: z.string().optional(),
});
